import { render, staticRenderFns } from "./CustomerProspectSubscription.vue?vue&type=template&id=83dd73c4&scoped=true"
import script from "./CustomerProspectSubscription.vue?vue&type=script&lang=js"
export * from "./CustomerProspectSubscription.vue?vue&type=script&lang=js"
import style0 from "./CustomerProspectSubscription.vue?vue&type=style&index=0&id=83dd73c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dd73c4",
  null
  
)

export default component.exports